import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	unsplashNoResultsText: {
		id: 'custom-sites-extensions.unsplash.search.no.results.text',
		defaultMessage: 'Nothing matches your search',
		description: 'Text to inform when there are no Unsplash image results to render',
	},
	unsplashNoMoreResultsToLoadText: {
		id: 'custom-sites-extensions.unsplash.search.no.more.results.to.load.text',
		defaultMessage: 'No more matches try another search',
		description: 'Text to inform when there are no more Unsplash image results to load',
	},
	unsplashLegal: {
		id: 'custom-sites-extensions.unsplash.legal',
		defaultMessage:
			'By using images from Unsplash, you agree to their {unsplashLicenseLink} and {unsplashTermsOfServiceLink}.',
		description: 'Text that explains the Unsplash legal agreements (license and terms of service)',
	},
	unsplashLicenseLink: {
		id: 'custom-sites-extensions.unsplash.license',
		defaultMessage: 'license',
		description: 'Text that links to Unsplash license',
	},
	unsplashTermsOfServiceLink: {
		id: 'custom-sites-extensions.unsplash.terms.of.service.',
		defaultMessage: 'Terms of Service',
		description: 'Text that links to Unsplash Terms of Service',
	},
});
